import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import AnimatedMainContainer from "../../../components/AnimatedMainContainer";
import { useDispatch, useSelector } from "react-redux";
import { getEventList } from "../../../redux/modules/analytics/actions";
import {
  getAdminBannersInfo,
  getPreviewCourseList,
  setBanner,
} from "../../../redux/modules/informaAcademy/actions";
import HomepageForm from "../components/form";
import PreviewHomePage from "../components/preview";
import api from "../../../service";
import { useToast } from "../../../hooks/toast";
import { convertToFormData } from "../CreateHomePage";

export default function EditHomePage() {
  const [step, setStep] = useState("preview");
  const intl = useIntl();
  const history = useHistory();
  const { eventId } = useParams();

  const { eventsInfo: events } = useSelector((state) => state.analytics);
  const {
    courses: eventCourses,
    banners: eventBanners,
    isLoadingCourses,
    isLoadingBanners,
  } = useSelector((state) => state.informaAcademy);
  const [banners, setBanners] = useState([]);
  const [courses, setCourses] = useState([]);
  const [loadBanners, setLoadBanners] = useState(false);
  const [loadCourses, setLoadCourses] = useState(false);
  const [choosenCourses, setChoosenCourses] = useState([]);
  const [isForm, setIsForm] = useState(false);
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { addToast } = useToast();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    dispatch(getEventList());
    dispatch(getPreviewCourseList({ eventId }));
    dispatch(getAdminBannersInfo({ eventId }));
  }, [dispatch, eventId]);

  useEffect(() => {
    if (loadBanners) return;
    if (eventBanners.length > 0) {
      setBanners(eventBanners);
      setLoadBanners(true);
    }
  }, [eventBanners, loadBanners]);

  useEffect(() => {
    if (loadCourses) return;
    if (eventCourses.length > 0) {
      setCourses(eventCourses);
      setLoadCourses(true);
    }
  }, [eventCourses, loadCourses]);

  const eventName = useMemo(() => {
    if (!events) return "";
    const name = events.find((event) => event.id === eventId)?.name;
    return name ? ` | ${name}` : "";
  }, [events, eventId]);

  const updateHomePage = async ({ body, homePageId }) => {
    try {
      await api.put(`academy/banners/homepage/${homePageId}`, body, config);
      addToast({
        type: "success",
        title: intl.formatMessage({
          id: "success",
        }),
        description: intl.formatMessage({
          id: "success.homepage_updated",
        }),
      });
      history.push(`/admin/informa-academy/manage-homepage/`);
    } catch (error) {
      addToast({
        type: "error",
        title: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "error.homepage_updated",
        }),
      });
    }
  };

  const onSubmit = async () => {
    const homepage = events.find((event) => event.id === eventId);

    if (!homepage?.homePageId) return;

    const { homePageId } = homepage;
    const body = convertToFormData({
      banners,
      courses,
      eventId,
      homePageId,
    });
    return await updateHomePage({ body, homePageId });
  };
  if (isLoadingCourses || isLoadingBanners) return null;

  if (step === "form")
    return (
      <AnimatedMainContainer
        breadcrumb={
          intl.formatMessage({
            id: "breadcrumb.edit-manage-homepage-banner",
          }) + eventName
        }
      >
        <HomepageForm
          defaultValues={{
            banners,
          }}
          eventCourses={eventCourses}
          setBanners={setBanners}
          setCourses={setCourses}
          preview={() => {
            setIsForm(true);
            setStep("preview");
          }}
          choosenCourses={choosenCourses}
          setChoosenCourses={setChoosenCourses}
        />
      </AnimatedMainContainer>
    );

  if (step === "preview")
    return (
      <AnimatedMainContainer
        goBack={!isForm && "/admin/informa-academy/manage-homepage"}
      >
        <PreviewHomePage
          banners={banners}
          courses={courses}
          editRedirect={() => setStep("form")}
          isForm={isForm}
          onSubmit={onSubmit}
          title={
            intl.formatMessage({
              id: "breadcrumb.edit-manage-homepage-banner",
            }) + eventName
          }
        />
      </AnimatedMainContainer>
    );

  return null;
}
